<h2 mat-dialog-title>{{description}}</h2>

<mat-dialog-content>
    <pre>
      {{content}}
    </pre>
</mat-dialog-content>
<mat-dialog-actions layout="row">
  <button class="mat-raised-button" mat-dialog-close>Close</button>
</mat-dialog-actions>
